import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import moment from "moment";
import { useTranslation } from 'react-i18next';


import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import ExtratoRoyaltiesDM2 from "beaktMatriz/views/Royalties/ExtratoRoyaltiesDM2";
import Slide from "@material-ui/core/Slide";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Help from "@material-ui/icons/Help";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from '@material-ui/core/CircularProgress';
import RoyaltyRow, { RoyaltyGroupTitle } from "beaktShared/components/RoyaltyRow/RoyaltyRow.js";

//services
import { SessionContext } from "beaktShared/services/session";
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { formateDate, transformValueFloattoFormated } from "beaktShared/helpers/masks";
import {
    isRegraV2, formatMoney, signTone, formatTaxa, parcelasExibicao, proximaCompetencia,
    totalReceberAVistaExibicao, memoriaCalculo, mediaParcelasV2, MODO_PARCELADO, MODO_AVISTA, MODO_AUTOMATICO, MODO_INTEGRAL
} from "beaktShared/helpers/royaltyDisplay";

//syles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import royaltyStyles from "assets/jss/material-dashboard-pro-react/components/royaltyRowStyle.js";
const useStyles = makeStyles(styles);
const useRoyaltyStyles = makeStyles(royaltyStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});
export default function RoyaltieForm({ addItem, item, handleView }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const royaltyClasses = useRoyaltyStyles();
    const regraV2 = isRegraV2(item);

    const { register, handleSubmit, setValue, errors, clearError } = useForm({ mode: "onChange" });

    const [loading, setloading] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    useEffect(() => {
        let dttemp = formateDate(moment(Date.now()));
        setValue("dtAceite", dttemp);
    }, []);

    const [parcelas, setparcelas] = React.useState('');
    const [valorParcelas, setvalorParcelas] = React.useState('');
    useEffect(() => {

        let dttemp = formateDate(moment(Date.now()));
        setValue("dtAceite", dttemp);

        if (!item.royaltieId)
            return;

        if (isRegraV2(item)) {
            setModoRecebimento(item.antecipacaoAutomatica ? MODO_AUTOMATICO : (item.modoRecebimento || MODO_PARCELADO));
            return;
        }

        verificaValorByParcelas();
    }, [item]);

    // Regra V2: modo escolhido pela clínica; os valores exibidos vêm do servidor
    const [modoRecebimento, setModoRecebimento] = React.useState(MODO_PARCELADO);
    const handleModoRecebimento = event => setModoRecebimento(event.target.value);

    const verificaValorByParcelas = (formapgto) => {
        if (item.parcelar <= 0) {
            setvalorParcelas(item.valorReceberPagar);
            setformapgto(1);
            setValue("formapgto", "1");
            setparcelas(1);
        }
        else if (item.parcelar > 0) {
            if (formapgto === "1" || item.mediaParcelas <= 1) {
                setformapgto(1);
                setValue("formapgto", "1");
                setvalorParcelas(item.valorFinal != null ? item.valorFinal : item.valorReceberComTaxaAntecipacao);
                setparcelas(1);
            }
            else {
                let CreditoAvista = item.valorCreditosAVista - item.valorDebitos;
                let valorParcela;

                if (CreditoAvista > 0)
                    valorParcela = item.valorCreditos / item.mediaParcelas;
                else
                    valorParcela = item.valorReceberPagar / item.mediaParcelas;

                // arredondando
                valorParcela = Math.round(valorParcela * 100) / 100;

                setvalorParcelas(valorParcela);
                setparcelas(item.mediaParcelas);
                setformapgto(2);
                setValue("formapgto", "2");
            }
        }
    }

    const [formapgto, setformapgto] = React.useState('');
    const hangleFormaPgto = event => {
        setformapgto(event.target.value);
        setValue("formapgto", event.target.value);
        if (event.target.value !== "")
            clearError("formapgto");
        verificaValorByParcelas(event.target.value);
    };

    const extractErrorMessage = (message) => {
        if (typeof message === "string") return message;
        if (message && typeof message === "object" && message.message) return message.message;
        return JSON.stringify(message);
    };

    const onSubmit = () => {

        let dtAceite = new Date();

        let obj = {
            ...item,
            usuarioAceiteId: parseInt(session.id),
            dataAceite: dtAceite,
            parcelaSelecionadaAceite: parcelas
        };

        if (regraV2) {
            obj.parcelaSelecionadaAceite = modoRecebimento === MODO_PARCELADO ? parcelasExibicao(mediaParcelasV2(item)) : 1;
            // Com antecipação automática o modo é definido pelo servidor e não é enviado
            if (item.antecipacaoAutomatica)
                delete obj.modoRecebimento;
            else
                obj.modoRecebimento = modoRecebimento;
        }

        let endPoint = "royalties/aceitefechamento";
        setloading(true);
        UsePostApi(endPoint, obj).then(result => {
            if (result.status !== 200) {
                showNotification(extractErrorMessage(result.message), 'danger');
                setloading(false);
                return false;
            }

            setloading(false);
            addItem(t('information_message.accepted_successfully'));
        });
    };

    const [showModal, setshowModal] = React.useState(false);
    const showExtrato = () => {
        setshowModal(true);
        /*history.push({
            pathname: '/adminclinic/extratoroyalties',
            state: { royaltieId: item.royaltieId, from: 'clinic' }
        });*/
    };

    const [memoriaAberta, setMemoriaAberta] = React.useState(false);

    const renderDatasAceitePagamento = () => (
        <>
            {/* A data do aceite é a do servidor no momento do aceite: antes dele não há data a exibir */}
            <RoyaltyRow label={t('label.accepted_date')} value={item.dataAceite ? formateDate(item.dataAceite) : "—"} />
            <RoyaltyRow
                label={t('label.payment_date')}
                value={item.dataPagamento ? formateDate(item.dataPagamento) : t('information_message.not_yet_informed')} />
        </>
    );

    const renderRegraV2 = () => {
        const automatica = item.antecipacaoAutomatica === true;
        const temDivida = (item.dividaAnterior || 0) > 0;
        const saldoRemanescente = (item.saldoDevedorRemanescente || 0) > 0;
        const parcelasMedia = parcelasExibicao(mediaParcelasV2(item));
        // Valores da API: taxa por parcela e base (Split Matriz Crédito + Resultado do Mês quando negativo)
        const pctParcela = formatMoney(item.taxaAntecipacaoPctParcela);
        const resultadoNegativo = (item.resultadoMes || 0) < 0 && (item.splitMatrizCredito || 0) > 0;
        const taxaSub = resultadoNegativo
            ? t('royaltie.v2_advance_rate_sub_negative_result', {
                pctParcela,
                parcelas: parcelasMedia,
                splitCredito: formatMoney(item.splitMatrizCredito),
                resultadoMes: formatMoney(Math.abs(item.resultadoMes))
            })
            : t('royaltie.v2_advance_rate_sub', {
                pctParcela,
                parcelas: parcelasMedia,
                baseTaxa: formatMoney(item.baseTaxaAntecipacao ?? item.splitMatrizCredito)
            });
        const taxaHelp = t(resultadoNegativo ? 'royaltie.v2_advance_rate_help_negative_result' : 'royaltie.v2_advance_rate_help', { pctParcela });
        const totalAVista = totalReceberAVistaExibicao(item, modoRecebimento);
        const totalAVistaHelp = modoRecebimento === MODO_INTEGRAL
            ? t('royaltie.v2_total_receive_integral_help')
            : modoRecebimento === MODO_AVISTA
                ? t('royaltie.v2_total_receive_cash_cash_help')
                : t('royaltie.v2_total_receive_cash_installments_help');

        return (
            <div style={{ maxWidth: '780px', margin: '0 auto' }}>

                <GridContainer alignItems="center" justify="space-between">
                    <GridItem xs={12} sm={6} md={6}>
                        <span className={royaltyClasses.ruleBadge + " " + royaltyClasses.ruleBadgeV2}>
                            {t('royaltie.v2_rule_banner')}
                        </span>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <h4 style={{ textAlign: 'right', fontWeight: 'bold' }}>{t('label.referent')}: {item.mesAno} </h4>
                    </GridItem>
                </GridContainer>

                <div style={{ border: '1px dashed gray', padding: '10px' }}>
                    <div style={{ border: '1px solid #61a4c982', padding: '10px 15px', background: '#61a4c926' }}>
                        <h3 style={{ textAlign: 'right' }}> {t('label.total_billing')}: {transformValueFloattoFormated(item.valorFaturamento ? item.valorFaturamento : 0)} </h3>
                    </div>

                    <RoyaltyGroupTitle>{t('royaltie.v2_group_month_composition')}</RoyaltyGroupTitle>
                    <RoyaltyRow label={t('royaltie.v2_status')} value={item.status} />
                    <RoyaltyRow label={t('label.value_royalties')} value={formatMoney(item.valorRoyalties)} />
                    <RoyaltyRow label={t('label.card_value')} value={formatMoney(item.valorCartao)} help={t('royaltie.v2_card_value_help')} />
                    <RoyaltyRow label={t('royaltie.v2_split_matrix_credit')} value={formatMoney(item.splitMatrizCredito)} />
                    <RoyaltyRow label={t('royaltie.v2_split_matrix_debit')} value={formatMoney(item.splitMatrizDebito)} />
                    <RoyaltyRow label={t('label.split_clinic')} value={formatMoney(item.valorRepasseSliptCartaoClinica)} help={t('royaltie.v2_split_clinic_help')} />
                    <RoyaltyRow label={t('royaltie.v2_cash_credits')} value={formatMoney(item.creditosAVista)} help={t('royaltie.v2_cash_credits_help')} />
                    <RoyaltyRow label={t('royaltie.v2_month_debits')} value={formatMoney(item.debitosMes)} help={t('royaltie.v2_month_debits_help')} />
                    <RoyaltyRow
                        label={t('royaltie.v2_month_result')}
                        value={formatMoney(item.resultadoMes)}
                        help={t('royaltie.v2_month_result_help')}
                        tone={signTone(item.resultadoMes)}
                        size="emphasis"
                        highlight />

                    <RoyaltyGroupTitle>{t('royaltie.v2_group_debts_advance')}</RoyaltyGroupTitle>
                    <RoyaltyRow
                        label={t('royaltie.v2_previous_debts')}
                        value={formatMoney(item.dividaAnterior)}
                        help={t('royaltie.v2_previous_debts_help')}
                        tone={temDivida ? "negative" : "neutral"} />
                    {automatica &&
                        <>
                            <RoyaltyRow label={t('royaltie.v2_uncovered_value')} value={formatMoney(item.valorDescoberto)} help={t('royaltie.v2_uncovered_value_help')} tone="negative" />
                            <RoyaltyRow
                                label={t('royaltie.v2_advance_rate')}
                                value={formatTaxa(item.taxaAntecipacaoPct, item.taxaAntecipacaoValor)}
                                help={taxaHelp}
                                sub={taxaSub} />
                            <RoyaltyRow label={t('royaltie.v2_net_advanced_credit')} value={formatMoney(item.creditoLiquidoAntecipado)} help={t('royaltie.v2_net_advanced_credit_help')} />
                        </>
                    }
                    {!automatica && temDivida &&
                        <RoyaltyRow
                            label={t('royaltie.v2_result_after_debt')}
                            value={formatMoney(item.resultadoAposDivida)}
                            help={t('royaltie.v2_result_after_debt_help')}
                            tone={signTone(item.resultadoAposDivida)}
                            size="emphasis" />
                    }
                    {!automatica &&
                        <RoyaltyRow
                            label={t('royaltie.v2_advance_rate')}
                            value={t('royaltie.v2_advance_rate_not_applied')}
                            sub={temDivida ? t('royaltie.v2_advance_rate_debt_covered') : t('royaltie.v2_advance_rate_no_debt')} />
                    }

                    <RoyaltyGroupTitle>{t('royaltie.v2_group_receipt')}</RoyaltyGroupTitle>
                    <RoyaltyRow label={t('royaltie.v2_receipt_mode')}>
                        <TextField
                            fullWidth
                            select
                            variant="outlined"
                            value={modoRecebimento}
                            onChange={handleModoRecebimento}
                            name="modoRecebimento"
                            disabled={automatica || !!item.dataAceite}>
                            <MenuItem value={MODO_PARCELADO}>{t('royaltie.v2_receipt_mode_installments')}</MenuItem>
                            <MenuItem value={MODO_AVISTA}>{t('royaltie.v2_receipt_mode_cash')}</MenuItem>
                            {automatica && <MenuItem value={MODO_AUTOMATICO} disabled>{t('royaltie.v2_receipt_mode_automatic')}</MenuItem>}
                            {modoRecebimento === MODO_INTEGRAL && <MenuItem value={MODO_INTEGRAL} disabled>{t('royaltie.v2_receipt_mode_integral')}</MenuItem>}
                        </TextField>
                        {automatica &&
                            <div className={royaltyClasses.warningBox}>
                                <strong>!</strong>
                                <span>{t(temDivida ? 'royaltie.v2_automatic_advance_warning' : 'royaltie.v2_automatic_advance_warning_negative_result')}</span>
                            </div>
                        }
                    </RoyaltyRow>
                    {!automatica && modoRecebimento === MODO_PARCELADO &&
                        <RoyaltyRow
                            label={t('royaltie.v2_installment')}
                            value={`${parcelasMedia}x ${formatMoney(item.valorParcela)}`}
                            help={t('royaltie.v2_installment_help')} />
                    }
                    {!automatica && modoRecebimento === MODO_AVISTA &&
                        <RoyaltyRow
                            label={t('royaltie.v2_advance_rate')}
                            value={formatTaxa(item.taxaAntecipacaoPct, item.taxaAntecipacaoValor)}
                            help={taxaHelp} />
                    }
                    {!automatica &&
                        <RoyaltyRow label={t('royaltie.v2_total_receive_cash')} value={formatMoney(totalAVista)} help={totalAVistaHelp} />
                    }
                    {renderDatasAceitePagamento()}

                    {automatica &&
                        <>
                            <RoyaltyGroupTitle>{t('royaltie.v2_group_closing_result')}</RoyaltyGroupTitle>
                            {saldoRemanescente ?
                                <RoyaltyRow
                                    label={t('royaltie.v2_remaining_debt')}
                                    value={formatMoney(item.saldoDevedorRemanescente)}
                                    help={t('royaltie.v2_remaining_debt_help')}
                                    sub={t('royaltie.v2_remaining_debt_sub', { competencia: proximaCompetencia(item.mesAno) })}
                                    tone="negative"
                                    size="large"
                                    highlight="negative" /> :
                                <RoyaltyRow
                                    label={t('royaltie.v2_amount_to_deposit')}
                                    value={formatMoney(item.valorDepositar)}
                                    help={t('royaltie.v2_amount_to_deposit_help')}
                                    tone="positive"
                                    size="large"
                                    highlight="positive" />
                            }
                        </>
                    }
                </div>

                <button type="button" className={royaltyClasses.memoryToggle} onClick={() => setMemoriaAberta(!memoriaAberta)}>
                    {memoriaAberta ? t('royaltie.v2_memory_hide') : t('royaltie.v2_memory_show')}
                </button>
                {memoriaAberta &&
                    <div className={royaltyClasses.memoryBox}>
                        {memoriaCalculo(item, modoRecebimento).map(linha => (
                            <div key={linha.labelKey} className={royaltyClasses.memoryLine}>
                                <span>{t(linha.labelKey, linha.labelParams)}</span>
                                <span>{linha.valueKey ? t(linha.valueKey) : linha.value}</span>
                            </div>
                        ))}
                    </div>
                }
            </div>
        );
    };
    
    return (
        <div className="maxContent">

            {loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }

            <form onSubmit={handleSubmit(onSubmit)} className="no-print">
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    {regraV2 ? <AttachMoney /> : <PermIdentity />}
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('information_message.royalties_closing')} <small>{t('label.track_status')}</small>
                                    <input className={classes.hidden} defaultValue={0} name="id" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody>

                                {regraV2 ? renderRegraV2() :
                                <div style={{ maxWidth: '500px', margin: '0 auto' }}>

                                    {item.regraVersao &&
                                        <span className={royaltyClasses.ruleBadge + " " + royaltyClasses.ruleBadgeLegacy}>
                                            {t('royaltie.legacy_rule_banner')}
                                        </span>
                                    }
                                    <h4 style={{ textAlign: 'right', fontWeight: 'bold' }}>{t('label.referent')}: {item.mesAno} </h4>
                                    <div style={{ border: '1px dashed gray', padding: '10px' }}>

                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <div style={{ border: '1px solid #61a4c982', padding: '10px 15px', background: '#61a4c926' }}>
                                                    <h3 style={{ textAlign: 'right' }}> {t('label.total_billing')}: {transformValueFloattoFormated(item.valorFaturamento ? item.valorFaturamento : 0)} </h3>
                                                </div>
                                            </GridItem>
                                        </GridContainer>
                                        <br />

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> STATUS:</h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label>{item.status}</label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> {t('label.value_royalties')}:</h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorRoyalties ? item.valorRoyalties : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> {t('label.card_value')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorCartao ? item.valorCartao : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.split_matrix')}:</h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label>
                                                    {transformValueFloattoFormated(item.valorRepasseSliptCartaoMatriz ? item.valorRepasseSliptCartaoMatriz : 0)}
                                                </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.split_clinic')}:</h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label>
                                                    {transformValueFloattoFormated(item.valorRepasseSliptCartaoClinica ? item.valorRepasseSliptCartaoClinica : 0)}
                                                </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> {t('label.credit_value_closing')}:
                                                    <Tooltip title="Exceto moderninha e crédito de Parcelamentos anteriores" placement="top">
                                                        <Help className="question" />
                                                    </Tooltip>
                                                </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label>  {transformValueFloattoFormated(item.valorCreditos ? item.valorCreditos : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.credit_cash_amount')} :
                                                    <Tooltip title="Moderninha + Crédito de parcelamentos anteriores" placement="top">
                                                        <Help className="question" />
                                                    </Tooltip> </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorCreditosAVista ? item.valorCreditosAVista : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.debit_value')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorDebitos ? item.valorDebitos : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        {item.valorReceberAVista > 0 &&
                                            <GridContainer>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <h6 className="tRightForm"> {t('label.value_receive_in_cash')}:
                                                        <Tooltip title="Valor crédito a vista - Valor débito" placement="top">
                                                            <Help className="question" />
                                                        </Tooltip> </h6>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <label> {transformValueFloattoFormated(item.valorReceberAVista ? item.valorReceberAVista : 0)} </label>
                                                </GridItem>
                                            </GridContainer>
                                        }

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.accepted_date')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {item.dataAceite ? formateDate(item.dataAceite) : ""} </label>
                                                {!item.dataAceite &&
                                                    <TextField
                                                        style={{ marginBottom: '10px' }}
                                                        variant="outlined"
                                                        inputRef={register({ required: t('label.required') })}
                                                        name="dtAceite"
                                                        InputLabelProps={{ shrink: true }}
                                                        disabled
                                                    />}
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.payment_date')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {item.dataPagamento ? formateDate(item.dataPagamento) : t('information_message.not_yet_informed')} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm"> {t('label.total_a')} {item.valorReceberPagar >= 0 ? t('label.to_receive') : t('label.to_pay')}:
                                                    <Tooltip title="Valor total arrecadado no mês" placement="top">
                                                        <Help className="question" />
                                                    </Tooltip> </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {transformValueFloattoFormated(item.valorReceberPagar ? item.valorReceberPagar : 0)} </label>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.billing_in_cash_or_installed')}? </h6>

                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <TextField
                                                    fullWidth
                                                    select
                                                    variant="outlined"
                                                    value={formapgto}
                                                    onChange={hangleFormaPgto}
                                                    name="formapgto"
                                                    ref={() => register({ name: "formapgto" }, { required: true })}
                                                    InputLabelProps={{ shrink: true }}
                                                    disabled={
                                                        item.dataAceite ||
                                                        !(item.valorReceberPagar > 0 && item.mediaParcelas > 1)
                                                    }>
                                                    <MenuItem value="1"> {t('label.in_cash')} </MenuItem>
                                                    {
                                                        item.valorReceberPagar > 0 && item?.mediaParcelas > 1 &&
                                                        (
                                                        <MenuItem value="2">{t('label.parceled')} </MenuItem>
                                                        )
                                                    }
                                                </TextField>
                                                <FormHelperText>
                                                    {errors.formapgto && <span className="obg">{t('label.required')} </span>}
                                                </FormHelperText>
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <h6 className="tRightForm">{t('label.parcel2')}: </h6>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={6}>
                                                <label> {parcelas}</label>x {transformValueFloattoFormated(valorParcelas ? valorParcelas : 0)}
                                            </GridItem>
                                        </GridContainer>
                                        {
                                            item.totalReceberAVista > 0 &&
                                            <GridContainer>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <h6 className="tRightForm"> {t('label.value_receive_in_cash')}:
                                                        <Tooltip title="Valor a ser recebido a vista: Crédito a vista + valor de 1 parcela" placement="top">
                                                            <Help className="question" />
                                                        </Tooltip> </h6>
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={6}>
                                                    <label> {transformValueFloattoFormated(item.totalReceberAVista ? item.totalReceberAVista : 0)} </label>
                                                </GridItem>
                                            </GridContainer>
                                        }
                                    </div>
                                </div>}

                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <br />
                        <div className={classes.textCenter}>
                            <Button onClick={() => handleView()} color="transparent" className={classes.updateProfileButton}>
                                {t('label.return')}
                            </Button>
                            <Button color="rose" onClick={e => { showExtrato() }}>
                                {t('information_message.view_the_extract')}
                            </Button>
                            {!item.dataAceite &&
                                <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                    {t('information_message.confirm_close')}
                                    {loading && <div> ...{t('label.loading')} </div>}
                                </Button>
                            }
                        </div>
                    </GridItem>
                </GridContainer>
            </form>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification(false)}
                close
            />

            <Dialog
                classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                open={showModal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModal(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description">
                <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{ background: '#5c4477' }}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={() => setshowModal(false)}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('register.royalties_extract')} </h4>
                </DialogTitle>
                <DialogContent
                    id="classic-modal-slide-description"
                    className={classes.modalBody}
                    style={{ background: '#f0f0f0' }}>
                    <br />
                    {
                        item.franquiaId === 3 ?
                            <ExtratoRoyaltiesDM2 royaltieId={item.royaltieId}></ExtratoRoyaltiesDM2> :
                            <ExtratoRoyalties royaltieId={item.royaltieId}></ExtratoRoyalties>
                    }
                </DialogContent>
            </Dialog>
        </div>
    );
}